export const VERSION = "3.27.2" || 'Test version';
export const COVEO_FRAMEWORK = ['@coveo/atomic', '@coveo/quantic'];
